import React, {useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Button, Input, Space, Spin, Table, Tag} from "antd"
import {SearchOutlined} from "@ant-design/icons"
import moment from "moment"
import {FORMAT_DATE_FULL_TIME} from "../../../../helpers/constants"

PhoneNumberTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listCustomers: PropTypes.array
}

function PhoneNumberTable(props) {
    const {loading, setArrSelected, listCustomers, selectedRowKeys, setSelectedRowKeys} = props
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const listDateFilter = ['bookedDate', 'blockeDateVTL', 'blockeDateMBF', 'blockeDateVNA']

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => {
            // eslint-disable-next-line array-callback-return
            const listFilter = listCustomers.filter((item) => selectedKeys.includes(item.key))
            setArrSelected(listFilter)
            setSelectedRowKeys(selectedKeys);
        },
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };

    const mapStatus = (value, status) => {
        switch (value) {
            case 0:
                return <Tag color="#531dab">{status}</Tag>
            case 1:
                return <Tag color="#108ee9">{status}</Tag>
            case 2:
                return <Tag color="#2db7f5">{status}</Tag>
            case 3:
                return <Tag color="#f50">{status}</Tag>
            case 8:
                return <Tag color="#9100ff">{status}</Tag>
            case 9:
                return <Tag color="#d4380d">{status}</Tag>
            case -1:
                return <Tag color="#87d068">{status}</Tag>
            default:
                return <Tag color="#000000">{status}</Tag>
        }
    }

    const mapStatusLock = (value) => {
        switch (value) {
            case 'Khóa':
                return <Tag color="#ff0000">{value}</Tag>
            case 'Hoạt động':
                return <Tag color="#108ee9">{value}</Tag>
            default:
                return <Tag color="#000000">{value}</Tag>
        }
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, close}) => (
            <div
                className='filterCustom'
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) => {
            if (listDateFilter?.includes(dataIndex)) {
                return record && moment(record[dataIndex]).format(FORMAT_DATE_FULL_TIME)?.toString()?.toLowerCase()?.includes(value?.toLowerCase())
            }

            return record && record[dataIndex]?.toString()?.toLowerCase()?.includes(value?.toLowerCase())
        },
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? text : text,
    })

    const columns = [
        {
            title: 'Khách hàng',
            dataIndex: 'teantName',
            key: 'teantName',
            width: 150,
            ...getColumnSearchProps('teantName'),
        },
        {
            title: 'Đầu số ảo',
            dataIndex: 'shortPhone',
            key: 'shortPhone',
            width: 120,
            ...getColumnSearchProps('shortPhone'),
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phoneNumber',
            className: 'phoneNumber',
            key: 'phoneNumber',
            width: 140,
            sorter: (a, b) => a.phoneNumber.length - b.phoneNumber.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('phoneNumber'),
        },
        {
            title: 'Telco',
            dataIndex: 'telco',
            className: 'Telco',
            key: 'telco',
            width: 90,
            ...getColumnSearchProps('telco'),
        },
        {
            title: 'Ngày book',
            dataIndex: 'bookedDate',
            key: 'bookedDate',
            width: 160,
            ...getColumnSearchProps('bookedDate'),
            render: (text) => {
                return text && moment(text).format(FORMAT_DATE_FULL_TIME)
            }
        },
        {
            title: 'Brand Name',
            dataIndex: 'brandName',
            key: 'brandName',
            width: 130,
            ...getColumnSearchProps('brandName'),
        },
        {
            title: 'Trạng thái chung',
            dataIndex: 'status',
            key: 'status',
            width: 150,
            ...getColumnSearchProps('status'),
            render: (text, record) => {
                return mapStatus(record.status, record.strStatus)
            }
        },
        {
            title: 'Trạng thái gọi VTL',
            dataIndex: 'statusLockVTL',
            key: 'statusLockVTL',
            width: 150,
            ...getColumnSearchProps('statusLockVTL'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVTL)
            }
        },
        // {
        //     title: 'Số lần mở VTL',
        //     dataIndex: 'blockedNumVTL',
        //     key: 'blockedNumVTL',
        //     ...getColumnSearchProps('blockedNumVTL'),
        // },
        {
            title: 'Thời gian khóa VTL',
            dataIndex: 'blockeDateVTL',
            key: 'blockeDateVTL',
            width: 160,
            ...getColumnSearchProps('blockeDateVTL'),
            render: (text) => {
                return text && moment(text).format(FORMAT_DATE_FULL_TIME)
            }
        },
        {
            title: 'Trạng thái gọi MBF',
            dataIndex: 'statusLockMBF',
            key: 'statusLockMBF',
            width: 150,
            ...getColumnSearchProps('statusLockMBF'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockMBF)
            }
        },
        // {
        //     title: 'Số lần mở MBF',
        //     dataIndex: 'blockedNumMBF',
        //     key: 'blockedNumMBF',
        //     ...getColumnSearchProps('blockedNumMBF'),
        // },
        {
            title: 'Thời gian khóa MBF',
            dataIndex: 'blockeDateMBF',
            key: 'blockeDateMBF',
            width: 160,
            ...getColumnSearchProps('blockeDateMBF'),
            render: (text) => {
                return text && moment(text).format(FORMAT_DATE_FULL_TIME)
            }
        },
        {
            title: 'Trạng thái gọi VNA',
            dataIndex: 'statusLockVNA',
            key: 'statusLockVNA',
            width: 150,
            ...getColumnSearchProps('statusLockVNA'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVNA)
            }
        },
        // {
        //     title: 'Số lần mở VNA',
        //     dataIndex: 'blockedNumVNA',
        //     key: 'blockedNumVNA',
        //     ...getColumnSearchProps('blockedNumVNA'),
        // },
        {
            title: 'Thời gian khóa VNA',
            dataIndex: 'blockeDateVNA',
            key: 'blockeDateVNA',
            width: 160,
            ...getColumnSearchProps('blockeDateVNA'),
            render: (text) => {
                return text && moment(text).format(FORMAT_DATE_FULL_TIME)
            }
        },
        {
            title: 'Nguồn',
            dataIndex: 'source',
            key: 'source',
            width: 110,
            ...getColumnSearchProps('source'),
        },
        {
            title: 'Khách hàng đã gán trước đó',
            dataIndex: 'prevTenantName',
            key: 'prevTenantName',
            width: 200,
            ...getColumnSearchProps('prevTenantName'),
        },
    ]

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu">
                <Table
                    className='TablePhoneNumber'
                    rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                    }}
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={listCustomers}
                    pagination={false}
                />
            </Spin>
        </div>
    )
}

export default PhoneNumberTable
